import { Sprite, Texture, Container } from "PIXI";
import * as PIXI from "PIXI";
export var options = {
    backgroundColor: 1087931,
    resolution: 1
};
export var renderer = PIXI.autoDetectRenderer(500, 500, options);
export var gameDiv = document.getElementById("game");
gameDiv.appendChild(renderer.view);
export var stage = new Container();
export var texture = Texture.fromImage("./build/assets/bunny.png");
export var bunny = new Sprite(texture);
bunny.anchor.x = 0.5;
bunny.anchor.y = 0.5;
bunny.position.x = 250;
bunny.position.y = 250;
stage.addChild(bunny);
export function animate(dt) {
    window.requestAnimationFrame(function (delegateArg0) {
        animate(delegateArg0);
    });
    bunny.rotation = bunny.rotation + 0.1;
    bunny.position.x = Math.sin(dt / 1000) * 100 + 250;
    bunny.position.y = -Math.cos(dt / 1000) * 100 + 250;
    renderer.render(stage);
}
animate(0);